import React from "react";
import Service from "../Items/Service";

const servicesData = [
  {
    id: 1,
    name: "Mobile Front-end",
    content:
      "Skills to lead mobile projects with best practices. From scratch to deploy to virtual stores.",
    icon: "icon-globe",
  },
  {
    id: 2,
    name: "Web Front-end",
    content:
      "Dashboards, institutional or PWAs. I'm used to building beautiful, pixel perfect and performing apps.",
    icon: "icon-chemistry",
  },
  {
    id: 3,
    name: "NodeJs Backend",
    content:
      "Great notions on how to play around Backend project. Working with AWS, Firebase, NoSql and Postgres.",
    icon: "icon-directions",
  },
  {
    id: 4,
    name: "A11y & Testing",
    content:
      "I have applied the best practices of Accessibility and also Tests. Both automated and unit tests.",
    icon: "icon-rocket",
  },
  {
    id: 5,
    name: "Agile",
    content:
      "Since 2016 working with agile methodologies such as Sprint, Scrum, Design thinking and Kanban.",
    icon: "icon-note",
  },
  {
    id: 6,
    name: "Soft Skills",
    content:
      "I have read over 300 books on personal growth, leadership, emotional intelligence and business.",
    icon: "icon-bubbles",
  },
];

function Services() {
  return (
    <div className="row -mt-20">
      {servicesData.map((service) => (
        <div className="col-md-4 col-sm-6 mt-20" key={service.id}>
          <Service service={service} />
        </div>
      ))}
    </div>
  );
}

export default Services;
